var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('batches-filter',{staticClass:"mb-5"}),_vm._v(" "),_c('batches-list')],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }